import React, {useContext, useState} from 'react';
import GettingStartedContext from "../utils/GettingStartedContext";

const DownloadPopup = () => {

  const [email, setEmail] = useState('');
  const [city, setCity] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [thankYou, setThankYou] = useState(false);

  const {
    link,
    data,
    showDownloadPricing,
    setShowDownloadPricing,
    langString,
    getProperty,
    lang,
    plan,
    plane
  } = useContext(GettingStartedContext);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Pardot Client Side Submission
    fetch(`https://www2.airsprint.com/l/95002/2024-03-13/7v224s?FirstName=${firstName}&LastName=${lastName}&Phone=${phone}&Email=${email}`, {
        method:'GET'
    }).then((response) => response.json())

    fetch(
      link + '/download',
      {
        method: 'POST',
        body: JSON.stringify({
          plane: {"ID":plane},
          email: email,
          city: city,
          firstName: firstName,
          lastName: lastName,
          phone: phone,
          language: lang,
          downloadTitle: getProperty(plan.LeasingOptions,'DownloadName'),
          downloadLink: getProperty(plan.LeasingOptions,'DownloadLink'),
          // answers: props.submittedQuestions,
          // formData: props.submittedForm,
          // plane: props.submittedQuestions.length > 0 ? props.result.data.BestPlane : props.result.data.Plane,
          // filters: props.manuallySelectedOptions,
        })
      }
    )
      .then((response) => response.json())
      .then((json) => {
        setThankYou(true);
      });
    return false;
  };

  return <div className="gsa-download__popup">
    <div className="gsa-download__popup__contents">
      <div className="gsa-download__popup__inner">
        <div className="gsa-download__popup__scroll">
          <a
            href="#"
            className="gsa-download__popup__close"
            onClick={(e) => {
              e.preventDefault();
              setShowDownloadPricing(false);
            }}>
            <img
              src="_resources/themes/airsprint/images/gsa/download-exit-icon.svg"
              className="exit-icon" />
          </a>

          {!thankYou && <div>
            <h3>{ data.DownloadPopupTitle }</h3>
            <div className="gsa-download__popup__text"
                 dangerouslySetInnerHTML={{__html: data.DownloadPopupContent }} />
            <form className="gsa-download__popup__form" onSubmit={handleSubmit}>
              <div className="field">
                <input name='FirstName'
                       required={true}
                       type="text"
                       value={firstName}
                       placeholder={data.FirstNameHolder}
                       onChange={(e) => { setFirstName(e.target.value) }} />
              </div>
              <div className="field">
                <input name='LastName'
                       required={true}
                       type="text"
                       value={lastName}
                       placeholder={data.LastNameHolder}
                       onChange={(e) => { setLastName(e.target.value) }} />
              </div>
              <div className="field">
                <input name='Email'
                       required={this}
                       type="email"
                       value={email}
                       placeholder={data.EmailHolder}
                       onChange={(e) => { setEmail(e.target.value) }} />
              </div>
              <div className="field">
                <input
                  name='Phone'
                  type="text"
                  value={phone}
                  placeholder={data.PhoneHolder}
                  onChange={(e) => { setPhone(e.target.value) }} />
              </div>
              <div className="field">
                <input name='City'
                       type="text"
                       required={true}
                       value={city}
                       placeholder={langString('CITY_LOCATION')}
                       onChange={(e) => { setCity(e.target.value) }} />
              </div>
              <input name="Download" type="hidden"
                     value={getProperty(plan.LeasingOptions,'DownloadName')}/>
              <div className="action">
                <button className="button secondary">Submit</button>
              </div>
            </form>
          </div>}
          {!!thankYou && <div>
            <h3>{ data.DownloadThankYouPopupTitle }</h3>
            <div className="gsa-download__popup__text" dangerouslySetInnerHTML={{__html: data.DownloadThankYouPopupContent }} />
            {!!(data.DownloadCTA1Title || data.DownloadCTA2Title) && <div className="gsa-download__popup__actions">
              {!!data.DownloadCTA1Title && <a
                className="button primary"
                target={data.DownloadCTA1NewWindow ? '_blank' : '_self'}
                href={data.DownloadCTA1URL}>
                { data.DownloadCTA1Title }
              </a> }
              {!!data.DownloadCTA2Title && <a
                className="button btn-border-bottom"
                target={data.DownloadCTA2NewWindow ? '_blank' : '_self'}
                href={data.DownloadCTA2URL}>
                { data.DownloadCTA2Title }
              </a> }
            </div>}
          </div>}
        </div>
      </div>
    </div>
  </div>
}

export default DownloadPopup;
